import { Type } from "class-transformer";
import { RACGP_COMPANY_UUID } from "src/common/constants/api.constants";
import { RolesEnum } from "../auth/contracts/role.contract";
import { BaseModel } from "../base.model";
import { Company } from "../crm/company.model";
import { Deal } from "../crm/deal.model";
import { Role } from "./role.model";
import type { User } from "./user.model";

export class UserRole extends BaseModel {
  uuid: string;
  id: number;
  name: string;
  description: string;
  user: User;
  @Type(() => Role)
  role: Role;
  @Type(() => Boolean)
  enabled: boolean;
  company?: Company;
  deal?: Deal;

  public hasPermission(permissionId: number): boolean {
    if (!this.enabled || !this.role.permissions || this.role.permissions.length === 0) {
      return false;
    }
    return this.role.permissions.some((permission) => permission.id === permissionId);
  }

  public get isOperations(): boolean {
    return this.role.id === RolesEnum.Operations;
  }

  public get isClient(): boolean {
    return this.role.id === RolesEnum.Client;
  }

  public get isPractitioner(): boolean {
    return this.role.id === RolesEnum.Practitioner;
  }

  public get isAdmin(): boolean {
    return this.role.id === RolesEnum.Admin;
  }

  public get isDRO(): boolean {
    return this.role.id === RolesEnum.DRO;
  }

  public get isCorporateAdmin(): boolean {
    return this.role.id === RolesEnum.CorporateAdmin;
  }
  public get isCollegeAdmin(): boolean {
    return this.role.id === RolesEnum.CollegeAdmin;
  }

  public get isKeyCompanyContact(): boolean {
    return this.role.id === RolesEnum.KeyCompanyContact;
  }

  public get isCorpAdminDelegate(): boolean {
    return this.role.id === RolesEnum.CorpAdminDelegate;
  }
  public get isCollegeAdminDelegate(): boolean {
    return this.role.id === RolesEnum.CollegeAdminDelegate;
  }

  public get isKeyCompanyContactDelegate(): boolean {
    return this.role.id === RolesEnum.KeyCompanyContactDelegate;
  }

  public get isDelegate(): boolean {
    return (
      this.isCorpAdminDelegate || this.isCollegeAdminDelegate || this.isKeyCompanyContactDelegate
    );
  }

  public get isInternalUser(): boolean {
    return this.isAdmin || this.isOperations || this.isDRO;
  }

  /**
   * Don't like doing this but we need to be able to identify this company
   */
  public get isRACGPUser(): boolean {
    return !!this.company && this.company.uuid === RACGP_COMPANY_UUID;
  }
}
